<template>
  <a-card :bordered="false">
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="type" slot-scope="text, record">
        {{ record | transLogDetailFilter }}
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getWayDetail } from "@/api/stock";

export default {
  name: "purchaseLog",
  components: {
    STable,
  },
  data() {
    return {
      loading: false,
      get_num: 0,
      columns: [
        {
          title: "时间",
          dataIndex: "created",
        },
        {
          title: "操作人",
          dataIndex: "admin_user_name",
        },
        {
          title: "操作内容",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
      ],
      loadData: (params) => {
        return getWayDetail({ ...params, id: this.$route.params.id }).then(
          (res) => res
        );
      },
    };
  },
  methods: {},
};
</script>
<style scoped></style>
